export default "__VITE_ASSET__326bc917__"